export default {
  namespaced: true,
  state: {
    list: [],
  },
  mutations: {
    add(state, payload) {
      state.list.push(payload);

      setTimeout(() => {
        state.list.shift();
      }, 4000);
    },
  },
};
